import { render } from "./OPINION_CHANGED_BY_ORG_SPLIT.vue?vue&type=template&id=74ded4fd"
import script from "./OPINION_CHANGED_BY_ORG_SPLIT.vue?vue&type=script&lang=js"
export * from "./OPINION_CHANGED_BY_ORG_SPLIT.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__